import Skeleton, {SkeletonProps} from '@mui/material/Skeleton';

import {styled} from '@mui/material/styles';

export const CSkeleton = styled(Skeleton)<SkeletonProps>(
  (/* { theme } */) => ({
  }),
);
